import { DEFAULT_FIAT_CURRENCY } from 'config/constants'

export function getFiatCurrency(currency: string): string {
  switch (currency) {
    case 'KISHU':
      return 'USDT'
  }
  return DEFAULT_FIAT_CURRENCY
}
